import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
// import logo from "../assets/img/logo.png";
import dropdashlogo from "../assets/img/dropdashlogo (2).png"
import { DataContext } from "../context/DataContext";

function TopHeader() {
  const result = useContext(DataContext);
  const employee = result?.employeeData;

  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // const userName = employee?.firstName || employee?.name || "";
  // const userName = employee?.firstName
  //   ? employee.firstName.charAt(0).toUpperCase() + employee.firstName.slice(1)
  //   : "";

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="navbar-container" style={{ backgroundColor: "white" }}>
      {/* Left */}
      <div className="navbar-logo pt-2"
      >
        <img
          src={dropdashlogo}
          className="header-brand-img text-start float-start error-logo-light"
          alt="logo"
          // onClick={() => navigate("/Dashboard")}
          role="button"
          style={{ marginLeft: "5px", cursor: "pointer" ,height: "35px",  width: "auto",}}
        />
      </div>

      {/* Right */}
      <div className="main-header-right d-flex flex-row-reverse ">
        <div className="navbar navbar-expand-lg nav nav-item navbar-nav-right responsive-navbar navbar-dark">
          <div className="d-flex order-lg-2 ms-auto">
            <div
              ref={dropdownRef}
              className="d-none d-md-flex align-items-center position-relative"
            >
              <div
                className="d-flex align-items-center d-none"
                style={{ cursor: "pointer" }}
                onClick={() => setShowDropdown(!showDropdown)}
              >
                <span style={{ color: "#2c3e50", fontSize: "15px" }}>
                  Welcome,{" "}
                  <strong>
                    {employee?.firstName
                      ? employee.firstName.charAt(0).toUpperCase() +
                      employee.firstName.slice(1)
                      : ""}
                  </strong>
                </span>

                <i
                  className="fa fa-user-circle ms-2"
                  style={{ fontSize: "26px", color: "#5e2c9e" }}
                ></i>
              </div>

              {showDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "55px",
                    right: "20px",
                    width: "140px",
                    background: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                    zIndex: 1000,
                    overflow: "hidden",
                  }}
                >
                  <div
                    onClick={handleLogout}
                    style={{
                      padding: "12px 15px",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#2c3e50",
                    }}
                  >
                    <i className="fa fa-sign-out me-2"></i>
                    Logout
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHeader;